<template>
  <HomeCards
    :id="id"
    :list="projects"
    :title="title"
  />
</template>


<script>

import HomeCards from './HomeCards.vue';

export default {
  components: {
    HomeCards,
  },
  props: {
    id: {
      type: String,
      default: 'projects',
    },
    title: {
      type: String,
      default: 'Projects',
    },
  },
  data() {
    return {
      projects: [
        {
          title: 'Teyvat',
          period: 'May 2021',
          subtitle: 'As a huge fan of the game Genshin Impact, I decided to create a website for that, where I wrote my guides and articles during my free time, it has been also an opportunity to try new technologies like gatsbyJS and tailwindcss',
          img: 'projects/teyvat.png',
          tags: [
            'GatsbyJS',
            'tailwindcss',
            'GraphQL',
            'leafletjs',
          ],
          links: [
            {
              content: 'Website',
              url: 'https://teyvat.netlify.app/',
              pack: 'fas',
              icon: 'external-link-alt',
            },
          ],
        },
        {
          title: 'Hikeero',
          period: 'July 2018 - August 2018',
          subtitle: 'An SPA project using the Hiking Project API, where users can visualize and filter available trails, more details on the github page',
          img: 'projects/hikeero.jpg',
          tags: [
            'ReactJS',
            'Redux',
            'ES6',
            'SCSS',
          ],
          links: [
            {
              content: 'Demo',
              url: 'https://hikeero.riceflake.com/',
              pack: 'fas',
              icon: 'external-link-alt',
            },
            {
              content: 'Source code',
              url: 'https://github.com/Riceflake/hikeero',
              pack: 'fab',
              icon: 'github',
            },
          ],
        },
        {
          title: 'Personal website',
          period: 'July 2018 - August 2018',
          subtitle: 'This website ! Responsive and built with VueJS and Bulma, I have tweaked some webpack / NGINX configuration in order to optimize the performance thanks to <a href="https://gtmetrix.com" target="_blank"/>GTmextrix</a>',
          img: 'projects/website.png',
          tags: [
            'VueJS',
            'Bulma',
            'SCSS',
            'NGINX',
            'CD/CI',
            'ES6',
            'Optimization / Performance',
          ],
        },
        {
          title: 'Simulation of an elevator',
          period: 'August 2018',
          subtitle: 'Simulate an elevator inside a building going from floor to floor, making stops when necessary. It is a technical test from <a href="https://makemereach.com" target="_blank"/>MakeMeReach</a> company, it was quite challenging because I never did RxJS and it was not obvious to plug my own code into the provided backbone of the application but I really enjoyed !',
          img: 'projects/elevator.png',
          tags: [
            'ReactiveX/rxjs',
            'ES6',
          ],
          links: [
            {
              content: 'Demo',
              url: 'https://rxjs-elevator-hjv9ct.stackblitz.io',
              pack: 'fas',
              icon: 'external-link-alt',
            },
            {
              content: 'Source code',
              url: 'https://stackblitz.com/edit/rxjs-elevator-hjv9ct?file=README.md',
              pack: 'fab',
              icon: 'github',
            },
          ],
        },
        {
          title: 'Playing with ReactJS',
          period: 'February 2018',
          subtitle: 'Display data from API files, it is a technical test from <a href="https://iwd.io" target="_blank"/>IWD</a> company, I never try ReactJS until I did this test and I enjoyed it but I preferred to stick with VueJS instead at that time',
          img: 'projects/react.png',
          tags: [
            'ReactJS',
            'Chart.js',
            'ES6',
          ],
          links: [
            {
              content: 'Demo',
              url: 'https://react.riceflake.com',
              pack: 'fas',
              icon: 'external-link-alt',
            },
            {
              content: 'Source code',
              url: 'https://github.com/Riceflake/tech-challenges/tree/master/frontend',
              pack: 'fab',
              icon: 'github',
            },
          ],
        },
        {
          title: 'Alix',
          period: 'May 2017 - January 2018',
          subtitle: 'Build an API and a B2B website, it is a project with a team of 4 people. I was in charge of the home layout, dashboard sidebar, dynamic FAQ, user settings, testable API pages',
          img: 'projects/alix.png',
          tags: [
            'VueJS',
            'Moment.js',
            'axios',
            'ES6',
          ],
          links: [
            {
              content: 'Demo',
              url: 'https://youtu.be/xDV7MBshgzQ',
              pack: 'fab',
              icon: 'youtube',
            },
          ],
        },
      ],
    };
  },
};
</script>
